module.exports = __webpack_public_path__ + "img/5.8d16cb01.svg";